// removed by extract-text-webpack-plugin
module.exports = {"pp-sans-big-light":"app__pp-sans-big-light___1LIvc","pp-sans-big-medium":"app__pp-sans-big-medium___EEIbt","pp-sans-big-thin":"app__pp-sans-big-thin___3Q0Oc","pp-sans-small-light":"app__pp-sans-small-light___2dPe8","pp-sans-small-regular":"app__pp-sans-small-regular___3I0OR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.less
 ** module id = 884
 ** module chunks = 0
 **/